var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { h, Component } from "preact";
export var isSameObject = function (obj1, obj2) {
    var keys1 = Object.keys(obj1);
    var keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    else if (keys1.length + keys2.length === 0) {
        return true;
    }
    return keys1.every(function (k) { return obj1[k] === obj2[k]; });
};
export default (function (middlewares) { return function (initState) {
    if (initState === void 0) { initState = {}; }
    var store = initState;
    var updateQueue = [];
    var connect = function (mapProps, mapDispatch) { return function (Com) { return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            var t = _this;
            t.execProps = t.execProps.bind(t);
            t.tempProps = t.execProps();
            t.tempUpdate = function () {
                var newProps = t.execProps();
                if (!isSameObject(t.tempProps, newProps)) {
                    t.tempProps = newProps;
                    t.forceUpdate && t.forceUpdate();
                }
            };
            updateQueue.push(t.tempUpdate);
            return _this;
        }
        class_1.prototype.execProps = function () {
            var props = this.props;
            var res1 = mapProps(props);
            var res2 = {};
            if (mapDispatch) {
                res2 = mapDispatch(Object.assign({}, props, res1));
            }
            return Object.assign({}, props, res1, res2);
        };
        class_1.prototype.componentWillUnmount = function () {
            updateQueue.splice(updateQueue.indexOf(this.tempUpdate), 1);
        };
        class_1.prototype.render = function () {
            return h(Com, __assign({}, this.tempProps));
        };
        return class_1;
    }(Component)); }; };
    return {
        connect: connect,
        getState: function () { return store; },
        dispatch: function (action, props) {
            var res = action(store);
            middlewares && middlewares.map(function (middleware) { return middleware(store, res, props); });
            if (res !== store) {
                store = res;
                updateQueue.map(function (f) { return f(); });
            }
        }
    };
}; });
//# sourceMappingURL=ipreact.js.map